import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: { // Exercise num
    unit: 'Unit 4',
    id: 'SB3-U4-P33-E1',
    audio: 'img/FriendsPlus/Page33/Audio/audio-e1-p33.mp3',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page33/E1/Key/answerKey.png',
    isAllowSubmit: false,
    textAlign: 'center',
    maxLength: 1,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page33/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page33/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page33/Audio/tieude-e1-p33.mp3' },
        { url: 'img/FriendsPlus/Page33/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page33/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page33/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page33/E1/6.jpg', input: true, answer: "2" },
        { url: 'img/FriendsPlus/Page33/E1/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page33/E1/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page33/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page33/E1/10.jpg', input: true, answer: "3" },
        { url: 'img/FriendsPlus/Page33/E1/11.jpg' },
        { url: 'img/FriendsPlus/Page33/E1/12.jpg', input: true, answer: "4" },
        { url: 'img/FriendsPlus/Page33/E1/13.jpg' },
      ],
    ]
  },
  2: { // Exercise num
    unit: 'Unit 4',
    id: 'SB3-U4-P31-E5',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page33/E2/1.jpg' }]],
  },
  3: { // Exercise num
    unit: 'Unit 4',
    id: 'SB3-U4-P33-E3',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: '',
    isAllowSubmit: false,
    hideBtnFooter: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page33/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page33/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page33/E3/3.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page33/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page33/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page33/E3/6.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page33/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page33/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page33/E3/9.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page33/E3/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page33/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page33/E3/12.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page33/E3/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page33/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page33/E3/15.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page33/E3/16.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page33/E3/17.jpg' },
      ],
    ],
  },
  4: { // Exercise num
    unit: 'Unit 4',
    id: 'SB3-U4-P33-E4',
    audio: '',
    video: '',
    component: UI,
    // recorder: true,
    question: [],
    questionImage: [
      [{ url: 'img/FriendsPlus/Page33/E4/1.jpg' }],
      [{ url: 'img/FriendsPlus/Page33/E4/2.jpg' }],
    ]
  },

}

export default json;